import React, { useState } from "react";
import { EXCHANGE_VALIDATION_EXCLUDING_KEYS } from "../../../utils/consts";

import DefaultButton from "../../styles/materialButtonStyle";
import MaterialDialog from "../../styles/materialDialog";
import { StyledExchangerActions } from "./styledExchanger";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";

const ExchangerConfirm = ({ t, exchange, createExchange, physicalExchangeData, isPhysical }) => {
  const [exchangeConfirm, setExchangeConfirm] = useState(false);

  const { inService, inCurrency, outService, outCurrency, inAmount } = exchange;

  const handleClose = () => {
    setExchangeConfirm(false);
  };

  const create = () => {
    for (let key in exchange) {
      if ((exchange[key] === null || exchange[key] === "") && !EXCHANGE_VALIDATION_EXCLUDING_KEYS.includes(key)) {
        return;
      }
    }
    setExchangeConfirm(true);
  };

  const isAvailableExchange = () => {
    if (Number(exchange.inAmount) < Number(physicalExchangeData.inMinAmount) ||
      Number(exchange.outAmount) < Number(physicalExchangeData.outMinAmount)) {
      return false;
    }

    if (isPhysical && !exchange?.connectionId) {
      return false;
    }

    if (!exchange.inCurrency || !exchange.outCurrency) {
      return false;
    }

    if (exchange.inCurrency === exchange.outCurrency && exchange.inService === exchange.outService) {
      return false;
    }

    return true;

  };

  return (
    <>
      {exchangeConfirm &&
        <MaterialDialog
          open={exchangeConfirm}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("exchanger.confirm.title")}
            </StyledDialogHead>
            <StyledDialogContent>
              {t("exchanger.confirm.text", {
                inAmount: inAmount,
                inCurrency: inCurrency,
                inService: inService,
                outService: outService,
                outCurrency: outCurrency
              })}
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
              >
                {t("exchanger.confirm.cancel")}
              </DefaultButton>
              <DefaultButton
                color="success"
                onClick={() => {
                  createExchange();
                  handleClose();
                }}
              >
                {t("exchanger.confirm.confirm")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>}

      <StyledExchangerActions>
        <DefaultButton
          color="success"
          onClick={create}
          disabled={!isAvailableExchange() || exchangeConfirm}
        >
          {t("exchanger.exchangeBtn")}
        </DefaultButton>
      </StyledExchangerActions>
    </>
  );
};

export default ExchangerConfirm;